import React from 'react';
import { message, Upload } from "antd";
import { Wrapper, CrossWrapper } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { color } from "../../theme/common";
export const UploadInput = ({
  title = "Attach",
  onUpload,
  value,
  disabled,
  onRemove,
  style,
  doc_key,
  hideRemoveBtn = false,
  hideFileName = false,
}) => {
  const props = {
    accept: ".png,.jpg,.jpeg,.pdf",
    customRequest: (e) => {
      onUpload(e.file);
    },
    className: `cg-upload ${disabled ? "disabled" : ""}`,
    showUploadList: false,
    disabled,
    beforeUpload: (file) => {
      const isLt3M = file.size / 1024 / 1024 < 3;
      //if (!isLt5M && file.type === "application/pdf") {
      if (!isLt3M) {
        message.error("Documents must be smaller than 3MB!");
      }
      return isLt3M;
    },
  };
  return (
    <Wrapper className="cg-upload-input" style={style}>
      {value ? (
        <div className="img-container">
          {value?.file?.type === "application/pdf" ? (
            <FontAwesomeIcon
              icon={faFilePdf}
              color={"#000"}
              style={{
                height: "40px",
                transform: "translate(-50%, -50%)",
                position: "absolute",
                top: "50%",
                left: "50%",
              }}
            />
          ) : (
            <img src={value?.base64} alt="" />
          )}
          {!hideRemoveBtn && (
            <CrossWrapper onClick={() => onRemove(doc_key)}>
              <FontAwesomeIcon
                icon={faXmark}
                color={color.white}
                style={{ height: 20 }}
              />
            </CrossWrapper>
          )}
        </div>
      ) : (
        <>
          <Upload {...props}>
            <FontAwesomeIcon
              icon={faPaperclip}
              color="#B5B5B5"
              style={{ height: 25 }}
            />
          </Upload>
        </>
      )}
      {!hideFileName && <span className="title">{title}</span>}
    </Wrapper>
  );
};
